import { Component } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html'
})
export class AppFooterComponent {
  year: number;

  constructor() {

    this.year = moment().year();

  }

}



// WEBPACK FOOTER //
// D:/Projects/mvdclick/frontend/src/app/components/app-footer/app-footer.component.ts